import React, {
    Fragment
} from 'react';
import styled from "styled-components";

const DesktopWidget = styled.div`
    display: none;

    ${props => props.theme.mediaQueries.medium}{
        display: inline;
    };
`

const MobileWidget = styled.div`
    ${props => props.theme.mediaQueries.medium}{
        display: none;
    };
`

const TrustPilotWidgets = () => {
    return (
        <Fragment>
            <DesktopWidget className="trustpilot-widget" data-locale="da-DK" data-template-id="5406e65db0d04a09e042d5fc" data-businessunit-id="4f0c3e070000640005122de4" data-style-height="28px" data-style-width="100%" data-theme="light">
                <a href="https://dk.trustpilot.com/review/www.privatsikring.dk" target="_blank" rel="noopener">Trustpilot</a>
            </DesktopWidget>

            <MobileWidget className="trustpilot-widget" data-locale="da-DK" data-template-id="53aa8912dec7e10d38f59f36" data-businessunit-id="4f0c3e070000640005122de4" data-style-height="140px" data-style-width="100%" data-theme="light" data-stars="1,2,3,4,5" data-review-languages="da">
                <a href="https://dk.trustpilot.com/review/www.privatsikring.dk" target="_blank" rel="noopener">Trustpilot</a>
            </MobileWidget>
        </Fragment> 
    )
}

export default TrustPilotWidgets